/* esm.sh - react-dom@18.2.0 */
export * from "https://esm.sh/v127/react-dom@18.2.0/X-ZS8q/denonext/react-dom.mjs";
export { default } from "https://esm.sh/v127/react-dom@18.2.0/X-ZS8q/denonext/react-dom.mjs";
